/** hint 事件 */
export enum HintEventActions {
  REC_CUS = 'rec_cus', // 领取
  REL_CUS = 'rel_cus', // 释放
  HINT = 'hint',
  SEND_MSG_FAILED = 'send_msg_failed', // 消息发送失败
  AGENT_UPDATE_CUSTOMER_INFO = 'agent_update_customer_info', // 编辑顾客信息
  WECHAT_COPY = 'wechat_copy',
  CHANGE_ENABEL_AI = 'cus_change_enable_ai', // 开启或关闭AI
  CHANGE_ENABEL_WORKFLOW = 'cus_change_enable_workflow', // 开启或关闭工作流
  CUS_CHANGE_ARCHIVE = 'cus_change_archive', // 归档
  CUS_TAGS_UNBIND = 'cus_tags_unbind', // 解绑标签
  CUS_TAGS_BIND = 'cus_tags_bind', // 绑定标签
  REDIRECT_CUS = 'redirect_cus', // 转接客服
  CUS_AUTO_DISABLE_AI = 'cus_auto_disable_ai', // 自动关闭AI
  CUS_DELAY_AUTO_ENABLE_AI = 'cus_delay_auto_enable_ai', // 延迟自动开启AI
  CUSTOMER_CREATE = 'customer_create', // 创建顾客
}
/** 被踢下线 */
export enum KickEventActions {
  KICK_SELF = 'kick_self',
  KICK_BY_PASSWORD_UPDATED = 'kick_by_password_updated',
}

export enum PreviewEventActions {
  PREVIEW = 'preview',
  PREVIEW_KNOWLEDGE = 'preview_knowledge',
  PREVIEW_MESSAGE = 'preview_message',
  PREVIEW_EVENT = 'preview_event',
  PREVIEW_DONE = 'preview_done',
}
